import { combineReducers } from "redux";
import configurationReducer from "./configuration/reducer";
import vehicleReducer from "./vehicle/reducer";
import overlayReducer from "./overlay/reducer";
import cameraReducer from "./camera/reducer";

const reducers = combineReducers({
  "configurationState": configurationReducer,
  "vehicleState": vehicleReducer,
  "overlayState": overlayReducer,
  "cameraState": cameraReducer
})

export default reducers;
export type State = ReturnType<typeof reducers>